export const Hanford_1_Device_Points_Config = {
  M1_BREAKER_STATUS: {
    shape: 'breaker',
    internalId: 'M1_BREAKER_STATUS',
    dataSourceDeviceType: 'rtac',
    dataSourceDeviceEngineeringId: 'm1_751',
    label: 'M1',
    points: [
      {
        label: 'M1 Breaker Status',
        pointName: 'm1_751_in101_52a',
        isStatusBinaryPoint: true,
      },
    ],
    dataPoints: [],
  },
  M1_BREAKER_POINTS: {
    shape: 'breaker',
    internalId: 'M1_BREAKER_POINTS',
    dataSourceDeviceType: 'rtac',
    dataSourceDeviceEngineeringId: 'xfmr_bu_87t2_2_487',
    label: 'M1',
    points: [
      {
        label: 'Active Power',
        pointName: 'm1_751_active_power',
        isStatusBinaryPoint: false,
      },
      {
        label: 'Reactive Power',
        pointName: 'm1_751_reactive_power',
        isStatusBinaryPoint: false,
      },
      {
        label: 'Frequency',
        pointName: 'm1_751_frequency',
        isStatusBinaryPoint: false,
      },
      {
        label: 'IA',
        pointName: 'm1_751_ia',
        isStatusBinaryPoint: false,
      },
      {
        label: 'VAB',
        pointName: 'm1_751_vab',
        isStatusBinaryPoint: false,
      },
    ],
    dataPoints: [],
  },
  F1_1_BREAKER_STATUS: {
    shape: 'breaker',
    internalId: 'F1_1_BREAKER_STATUS',
    dataSourceDeviceType: 'rtac',
    label: 'F1-1',
    dataSourceDeviceEngineeringId: 'f1_1_751',
    points: [
      {
        label: 'F1-1 Breaker Status',
        pointName: 'f1_1_751_in101_52a',
        isStatusBinaryPoint: true,
      },
    ],
    dataPoints: [],
  },
  F1_1_BREAKER_POINTS: {
    shape: 'breaker',
    internalId: 'F1_1_BREAKER_POINTS',
    dataSourceDeviceType: 'rtac',
    label: 'F1-1',
    dataSourceDeviceEngineeringId: 'xfmr_bu_87t2_2_487',
    points: [
      {
        label: 'Active Power',
        pointName: 'f1_1_751_active_power',
        isStatusBinaryPoint: false,
      },
      {
        label: 'Reactive Power',
        pointName: 'f1_1_751_reactive_power',
        isStatusBinaryPoint: false,
      },
      {
        label: 'Frequency',
        pointName: 'f1_1_751_frequency',
        isStatusBinaryPoint: false,
      },
      {
        label: 'IA',
        pointName: 'f1_1_751_ia',
        isStatusBinaryPoint: false,
      },
      {
        label: 'VAB',
        pointName: 'f1_1_751_vab',
        isStatusBinaryPoint: false,
      },
    ],
    dataPoints: [],
  },
  F1_2_BREAKER_STATUS: {
    shape: 'breaker',
    internalId: 'F1_2_BREAKER_STATUS',
    dataSourceDeviceType: 'rtac',
    label: 'F1-2',
    dataSourceDeviceEngineeringId: 'f1_2_751',
    points: [
      {
        label: 'F1-2 Breaker Status',
        pointName: 'f1_2_751_in101_52a',
        isStatusBinaryPoint: true,
      },
    ],
    dataPoints: [],
  },
  F1_2_BREAKER_POINTS: {
    shape: 'breaker',
    internalId: 'F1_2_BREAKER_POINTS',
    dataSourceDeviceType: 'rtac',
    label: 'F1-2',
    dataSourceDeviceEngineeringId: 'm1_52m1_751',
    points: [
      {
        label: 'Active Power',
        pointName: 'f1_2_751_active_power',
        isStatusBinaryPoint: false,
      },
      {
        label: 'Reactive Power',
        pointName: 'f1_2_751_reactive_power',
        isStatusBinaryPoint: false,
      },
      {
        label: 'Frequency',
        pointName: 'f1_2_751_frequency',
        isStatusBinaryPoint: false,
      },
      {
        label: 'IA',
        pointName: 'f1_2_751_ia',
        isStatusBinaryPoint: false,
      },
      {
        label: 'VAB',
        pointName: 'f1_2_751_vab',
        isStatusBinaryPoint: false,
      },
    ],
    dataPoints: [],
  },
  A1_BREAKER_STATUS: {
    shape: 'breaker',
    internalId: 'A1_BREAKER_STATUS',
    dataSourceDeviceType: 'rtac',
    label: '52-A1',
    dataSourceDeviceEngineeringId: 'a1_751',
    points: [
      {
        label: '52-A1 Breaker Status',
        pointName: 'a1_751_in101_52a',
        isStatusBinaryPoint: true,
      },
    ],
    dataPoints: [],
  },
  A1_BREAKER_POINTS: {
    shape: 'breaker',
    internalId: 'A1_BREAKER_POINTS',
    dataSourceDeviceType: 'rtac',
    label: '52-A1',
    dataSourceDeviceEngineeringId: 'm2_52m2_751',
    points: [
      {
        label: 'Active Power',
        pointName: 'a1_751_active_power',
        isStatusBinaryPoint: false,
      },
      {
        label: 'Reactive Power',
        pointName: 'a1_751_reactive_power',
        isStatusBinaryPoint: false,
      },
      {
        label: 'Frequency',
        pointName: 'a1_751_frequency',
        isStatusBinaryPoint: false,
      },
      {
        label: 'IA',
        pointName: 'a1_751_ia',
        isStatusBinaryPoint: false,
      },
      {
        label: 'VAB',
        pointName: 'a1_751_vab',
        isStatusBinaryPoint: false,
      },
    ],
    dataPoints: [],
  },
};
